import axios from 'axios';
import React, { useState } from 'react';
import { useEffect } from 'react';

const GameIntro = ({ changeState, datas, loaderVisible, user }) => {

  const [state, setState] = useState(0);
  const [intro, setIntro] = useState([]);
  const [checkpointLoaded, setCheckpointLoaded] = useState(false);

  const handleNext = () => {
    setState(state + 1);
  }

  const handlePreview = () => {
    setState(state - 1);
  }

  const startDefi = () => {
    loaderVisible();
    changeState();
  }

  const tmpArray = datas;

  useEffect(() => {
    console.log(datas)
    if (intro.length === 0) {
      setIntro(tmpArray);
    }
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: 'auto' // Cette ligne est facultative car 'auto' est le comportement par défaut
    });

    if(!checkpointLoaded){
      axios.get('https://connivence-salon.net/api/e-learning/game/get/checkpoint.php', {
        params: {
          user: user?.id
        }
      })
        .then(response => {
          if (response.data && response.data.success) {
            if(response.data.success !== "0"){
              startDefi();
            }
            setCheckpointLoaded(true);
          }
          // Traiter la réponse ici
        })
        .catch(error => {
          console.error('Erreur:', error);
          // Gérer l'erreur ici
        });
    }
  }, [state])

  return (
    <section className="game-intro">
      <div className="left-col">
        <img src="./assets/images/formateurs.png" alt="Romain et Stéphane les formateurs de Connivence" />
      </div>
      <div className="right-col">
  <div
    className="dialog-box"
    dangerouslySetInnerHTML={{ __html: intro[state] }}
  ></div>

  {state === intro.length - 1 && (
    <div className="signatures">
      <img
        src="./assets/images/signature_romain.png"
        alt="Signature de Romain"
      />
      <img
        src="./assets/images/signature_stephane.png"
        alt="Signature de Stéphane"
      />
    </div>
  )}

  <div className="intro-actions">
    {state === intro.length - 1 ? (
      <button className="play-button" onClick={() => startDefi()}>
        C'est parti !
      </button>
    ) : (
      <>
        <button
          className={state === 0 ? "previous disabled" : "previous"}
          onClick={() => (state === 0 ? null : handlePreview())}
        >
          <svg
            width="11"
            height="21"
            viewBox="0 0 11 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.48077 0L0 1.75L7.82692 10.5L0 19.25L1.48077 21L11 10.5L1.48077 0Z"
              fill="white"
            />
          </svg>
        </button>
        <button
          className="next"
          onClick={() =>
            state === intro.length - 1 ? null : handleNext()
          }
        >
          <svg
            width="11"
            height="21"
            viewBox="0 0 11 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.48077 0L0 1.75L7.82692 10.5L0 19.25L1.48077 21L11 10.5L1.48077 0Z"
              fill="white"
            />
          </svg>
        </button>
      </>
    )}
  </div>
</div>
    </section>
  );
};

export default GameIntro;